import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=5024009b&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=ts"
export * from "./CustomerProfile.vue?vue&type=script&lang=ts"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=5024009b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024009b",
  null
  
)

export default component.exports